<span
  *ngIf="label && (enabled$ | async)"
  [attr.data-element]="dataElement"
  class="badge badge-raspberry-clear items-center text-xs truncate">
  {{ label }}
</span>
